// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/impostazioni/zoho-sign/stato?societaId=N',
    requestBody: null,
    response: '{ success: true, data: { datacenter, credenziali: [{ nome, etichetta, presente }], verifiche: VerificaIntegrazione[], richieste: { giorni, perStato: [{ stato, numero }] } } }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/zoho-sign/verifica',
    requestBody: null,
    response: '{ success: true, data: { esitoOk, messaggio, durataMs } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
